import React from 'react';

function LayoutDefault({ children }) {
  return <div className="layout-default">{children}</div>;
}

export default LayoutDefault;
